// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PatientFinderPatientResponseAddress {
    'addressKey'?: string;
    'addressLine1'?: string;
    'addressLine2'?: string;
    'city'?: string;
    'rank'?: string;
    'source'?: string;
    'state'?: string;
    'type'?: string;
    'zipCode'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PatientFinderPatientResponseAddress>> = [
        {
            "name":     "addressKey",
            "baseName": "addressKey",
            "type":     "string"
        },
        {
            "name":     "addressLine1",
            "baseName": "addressLine1",
            "type":     "string"
        },
        {
            "name":     "addressLine2",
            "baseName": "addressLine2",
            "type":     "string"
        },
        {
            "name":     "city",
            "baseName": "city",
            "type":     "string"
        },
        {
            "name":     "rank",
            "baseName": "rank",
            "type":     "string"
        },
        {
            "name":     "source",
            "baseName": "source",
            "type":     "string"
        },
        {
            "name":     "state",
            "baseName": "state",
            "type":     "string"
        },
        {
            "name":     "type",
            "baseName": "type",
            "type":     "string"
        },
        {
            "name":     "zipCode",
            "baseName": "zipCode",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return PatientFinderPatientResponseAddress.attributeTypeMap;
    }
}
